import { Link } from 'react-router-dom';
import { Building2, ChevronDown, Plus, Check } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useActiveOrg } from '@/hooks/useActiveOrg';

/** Compact org switcher for the topbar. Renders nothing when the user has no memberships. */
export default function OrgSwitcher() {
  const { memberships, activeOrg, setActiveOrgId, loading } = useActiveOrg();

  if (loading || memberships.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="hidden md:inline-flex gap-2 max-w-[200px]">
          <Building2 className="h-4 w-4 shrink-0" />
          <span className="truncate">{activeOrg?.org_name ?? 'Select org'}</span>
          <ChevronDown className="h-3 w-3 shrink-0 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Organizations</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {memberships.map((m) => (
          <DropdownMenuItem
            key={m.org_id}
            onClick={() => setActiveOrgId(m.org_id)}
            className="flex items-center gap-2"
          >
            {m.org_id === activeOrg?.org_id ? (
              <Check className="h-4 w-4 text-primary" />
            ) : (
              <span className="h-4 w-4" />
            )}
            <span className="flex-1 truncate">{m.org_name}</span>
            <span className="text-xs text-muted-foreground capitalize">{m.role}</span>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/orgs" className="flex items-center">
            <Plus className="h-4 w-4 mr-2" /> Manage organizations
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
